import { Box, Stack, Typography } from '@mui/material'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'

const PasswordStrengthBar = observer(({ setErrorComplexPassword, password, errorComplexPassword, showError = true }) => {
    const [complexPassword, setComplexPassword] = useState({
        strengthPoint: false,
        background: '#F2F4F7',
        text: 'password_strength',
    })

    const totalBars = 5

    const description = [
        'Be_minimun_8_characters',
        'include_least_one_lowercase_letter',
        'include_least_one_uppercase_letter',
        'include_least_one_number',
        'include_least_one_special_character',
    ]
    
    const checkPasswordStrength = (password) => {
        let strength = 0   
        const errors = []
      
        const criteria = [
          {
            regex: /[a-z]/,
            error: 'error_password_least_one_lowercase',
          },
          {
            regex: /[A-Z]/,
            error: 'error_password_least_one_uppercase',
          },
          {
            regex: /[0-9]/,
            error: 'error_password_least_one_number',
          },
          {
            regex: /[!@#$%^&*(),.?":{}|<>+-/_=]/,
            error: 'error_password_least_one_special',
          },
        ]
      
        criteria.forEach(({ regex, error }) => {
          if (regex.test(password)) {
            strength++
          } else {
            errors.push(error)
          }
        })
      
        if (password.length >= 8) {
          strength++
        } else {
          errors.push('error_password_must_least_8_char')
        }

        setErrorComplexPassword(errors || '')
      
        const strengthLevels = [
          { background: '#F2F4F7', text: 'password_strength' }, 
          { background: '#F44336', text: 'very_weak' },         
          { background: '#FFF422', text: 'weak' },             
          { background: '#4CAF50', text: 'good' },             
          { background: '#4CAF50', text: 'strong' },           
          { background: '#4CAF50', text: 'strong' },
        ];
      
        const level = Math.min(strength, strengthLevels.length - 1)
      
        setComplexPassword({
            strengthPoint: strength,
            background: strengthLevels[level].background,
            text: strengthLevels[level].text,
        })
    }

    useEffect(() => {
        checkPasswordStrength(password)
    }, [password])

    return (
      <Stack sx={{ width: '100%', marginTop: '8px'}}>
        <Stack sx={{ width: '100%', flexDirection: 'row', gap: '5px' }}>
            {Array.from({ length: totalBars }).map((_, index) => (
                <Stack
                    key={index}
                    sx={{
                        width: '100%',
                        height: '6px',
                        background: index < complexPassword.strengthPoint ? complexPassword.background : '#F2F4F7',
                        borderRadius: '50px',
                        transition: 'background 0.3s ease',
                    }}
                />
            ))}
        </Stack>

        <Stack sx={{ width: '100%', marginTop: '4px'}}>
            <Typography sx={{ fontSize: '10px', fontWeight: 400, color: '#696969', textAlign: 'right' }}>
                <T>{complexPassword.text}</T>
            </Typography>
        </Stack>

        <Box sx={{
            marginTop: '20px',
            backgroundColor: '#E9F5FA',
            padding: '16px 24px',
            borderRadius: '8px',
        }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#0B3B61', marginBottom: '12px' }}>
                <T>your_password_must_be_contain</T>
            </Typography>
            {description.map((item, index) => (
                <Stack key={index} sx={{ display: 'flex', flexDirection: 'row', gap: '5px', paddingLeft: '8px' }}>
                    • <Typography sx={{ fontSize: '14px', fontWeight: 400, color: '#0B3B61', paddingLeft: '5px' }}> <T>{item}</T> </Typography>
                </Stack>
            ))}
        </Box>
        {errorComplexPassword.length > 0 && showError? (
            <Box
                mt={'20px'}
                sx={{
                    maxWidth: '100%',
                    borderRadius: '8px',
                    backgroundColor: '#FFE7EB',
                    padding: '15px 27px',
                    textAlign: 'center'
                }}>
                {errorComplexPassword.map((item, index, array) => (
                    <Stack key={index} sx={{ marginTop: index > 0 && '10px', paddingBottom: index < array.length -1 && '10px', borderBottom: index < errorComplexPassword.length - 1 && '1px dashed #FF6187' }}>
                        <Typography 
                            variant="desc" 
                            sx={{ width: '100%' }} 
                            fontSize="14px" 
                            fontWeight={400} 
                            color="#FF6187"
                            textDecorationStyle={'dashed'}
                            >
                            <T>{item}</T>
                        </Typography>
                    </Stack>
                ))}
            </Box>
        ) : null}
      </Stack>
    )
})

export default PasswordStrengthBar